import Vue from 'vue';

export default (params = {}) => (
    new Promise((resolve, reject) => {
      Vue.$http.post('/reports/turnover/client/send/bulk', params, {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    })
);



// WEBPACK FOOTER //
// ./src/app/services/report/sendTurnOverPdf.js